// components/create/TabNavigation.js
import React from 'react';
import '../../styles/TabNavigation.scss';
import Icon from '../Icon';

export default function TabNavigation({ activeTab, onTabChange, tabs }) {
  return (
    <div className="tab-navigation">
      <div className="tab-container">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.icon && <Icon name={tab.icon} />}
            <span>{tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}